import layout from '@/components/common/layout';
import psiList from '../views/psi/list';
import psiCreate from '../views/psi/create';
import psiLogList from '../views/psi/log-list';
import psiLogCreate from '../views/psi/log-create';

export default [
    {
        path: '/psi',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "货物列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '12',// 父选项
                        child: 'psi_list',// 子选项
                    }
                },
                component: psiList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增货物",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '12',// 父选项
                        child: 'psi_list',// 子选项
                    }
                },
                component: psiCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑货物",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '12',// 父选项
                        child: 'psi_list',// 子选项
                    }
                },
                component: psiCreate,
            },
            {
                path: 'log-list',
                meta: {
                    metaInfo: {
                        title: "进销存明细",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '12',// 父选项
                        child: 'psi_list',// 子选项
                    }
                },
                component: psiLogList,
            },
            {
                path: 'log-create',
                meta: {
                    metaInfo: {
                        title: "添加进销存",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '12',// 父选项
                        child: 'psi_list',// 子选项
                    }
                },
                component: psiLogCreate,
            },
        ]
    },
];
